import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LastMinutePackageOption from './LastMinutePackageOption'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'

import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import Caption from 'components/Luxkit/Typography/Caption'
import { sortPackageOptions } from 'lib/offer/offerPageUtil'
import config from 'constants/config'

const PackageSelectionWrapper = styled.div`
  ${mediaQueryUp.tablet} {
    position: relative;
    padding-right: ${rem(20)};
    padding-left: ${rem(20)};
  }

  > * + * {
    margin-top: ${rem(20)};
  }
`

const PriceClause = styled(Caption)`
  margin-top: ${rem(16)};
`

const PackageOptionsGrid = styled(LayoutContainer)`
  padding: 0;
`

interface Props {
  offer: App.Offer;
  showFlightInformation?: boolean;
  destinationAirport?: App.Airport;
  packageOptions: Array<OfferPackageOptionView>;
}

function LastMinutePackageOptions(props: Props) {
  const {
    showFlightInformation,
    destinationAirport,
    offer,
    packageOptions,
  } = props

  const sortedPackageOptions = useMemo(() => {
    return sortPackageOptions(packageOptions)
  }, [packageOptions])

  return (<PackageOptionsGrid>
    <PackageSelectionWrapper>
      {sortedPackageOptions.map((item) => <LastMinutePackageOption
        key={item.package.uniqueKey}
        offer={offer}
        packageView={item}
        flightDestination={destinationAirport}
      />)}
    </PackageSelectionWrapper>
    {showFlightInformation &&
      <PriceClause variant="medium" align="center">
        *Price is indicative and based on sample return fares (inclusive of booking fees on Low Cost Carriers).{' '}
        To view live pricing, conduct a full search. {config.brandConfig.name} full Terms and Conditions apply
      </PriceClause>
    }
  </PackageOptionsGrid>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  offer: state.offer,
  rooms: state.rooms,
  airport: state.airport,
  packageOptions: getDurationPackageOptions(state, appState),
}), LastMinutePackageOptions)
